import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Header from '../components/Header/Header';

const Accommodation = () => {
  return (
    <>
      <Header />
      <Navbar />
      <div className="min-h-screen flex flex-col items-center">
      <div className="flex flex-col items-center mt-16 p-6 bg-white rounded-lg w-11/12 max-w-3xl">
        <h1 className="text-2xl md:text-3xl text-center text-gray-800">Updates will be available soon. Stay tuned!</h1>
      </div>
    </div>
    </>
  );
};

export default Accommodation;
